"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reasonForDonatingSelect = exports.reasonForDonatingConfig = exports.reasonConfigs = exports.ReasonForDonatingDefinition = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _lodash = _interopRequireDefault(require("lodash"));

var _fieldDefinitionTypes = require("../../fields/config/fieldDefinitionTypes");

var _types = require("../../types");

var _config = require("../config");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var ListComponentConfigDefinition = _flowRuntime["default"].tdz(function () {
  return _config.ListComponentConfigDefinition;
});

var ComponentElementDefinition = _flowRuntime["default"].tdz(function () {
  return _types.ComponentElementDefinition;
});

var OptionDefinition = _flowRuntime["default"].tdz(function () {
  return _types.OptionDefinition;
});

var SelectDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.SelectDefinition;
});

var TextfieldDefinition = _flowRuntime["default"].tdz(function () {
  return _fieldDefinitionTypes.TextfieldDefinition;
});

var reasonForDonatingSelect = {
  key: 'reason',
  label: 'Reason for donating',
  type: 'select',
  validation: [{
    required: true
  }]
};
exports.reasonForDonatingSelect = reasonForDonatingSelect;
var reasonConfigs = [{
  selectItem: {
    key: 'personal_connection',
    label: 'I have a personal connection to blood cancer',
    value: 'personal_connection'
  },
  notesTextfield: {
    key: 'notes',
    label: "You can provide further details here if you\u2019d like to",
    type: 'text',
    validation: []
  }
}, {
  selectItem: {
    key: 'event',
    label: 'I have taken part in an event',
    value: 'event'
  },
  notesTextfield: {
    key: 'notes',
    label: 'Please tell us which event',
    type: 'text',
    validation: [{
      required: true
    }]
  }
}, {
  selectItem: {
    key: 'in_memory',
    label: 'I am giving in memory of someone',
    value: 'in_memory'
  },
  notesTextfield: {
    key: 'notes',
    label: 'Please tell us who',
    type: 'text',
    validation: [{
      required: true
    }]
  }
}, {
  selectItem: {
    key: 'money_raised',
    label: "I am paying in money I\u2019ve raised",
    value: 'money_raised'
  },
  notesTextfield: {
    key: 'notes',
    label: 'Please give further details',
    type: 'text',
    validation: [{
      required: true
    }]
  }
}, {
  selectItem: {
    key: 'company',
    label: 'My company is supporting Anthony Nolan',
    value: 'company'
  },
  notesTextfield: {
    key: 'notes',
    label: 'Company name and how you raised funds',
    type: 'text',
    validation: [{
      required: true
    }]
  }
}, {
  selectItem: {
    key: 'sponsorship',
    label: 'I am paying in sponsorship',
    value: 'sponsorship'
  },
  notesTextfield: {
    key: 'notes',
    label: 'Please tell us what event this money is for',
    type: 'text',
    validation: [{
      required: true
    }]
  }
}, {
  selectItem: {
    key: 'other',
    label: 'Other',
    value: 'other'
  },
  notesTextfield: {
    key: 'notes',
    label: 'Please give further details',
    type: 'text',
    validation: [{
      required: true
    }]
  }
}];
exports.reasonConfigs = reasonConfigs;
var reasonForDonatingConfig = {
  type: 'reasonForDonating',
  defaultItems: reasonConfigs.map(function (item) {
    return item.selectItem;
  }),
  fields: [reasonForDonatingSelect],
  validation: (0, _toConsumableArray2["default"])(_lodash["default"].reduce(reasonConfigs, function (rules, config) {
    var notesValidationRules = _lodash["default"].get(config, 'notesTextfield.validation', []);

    return [].concat((0, _toConsumableArray2["default"])(rules), (0, _toConsumableArray2["default"])(notesValidationRules.map(function (fieldRule) {
      return {
        validateIfFieldMatchesValue: {
          field: reasonForDonatingSelect.key,
          value: config.selectItem.value,
          validation: {
            fieldValidation: {
              field: config.notesTextfield && config.notesTextfield.key,
              validation: fieldRule
            }
          }
        }
      };
    })));
  }, []))
};
exports.reasonForDonatingConfig = reasonForDonatingConfig;

var ReasonForDonatingDefinition = _flowRuntime["default"].type("ReasonForDonatingDefinition", _flowRuntime["default"].spread(_flowRuntime["default"].ref(ComponentElementDefinition), _flowRuntime["default"].object(_flowRuntime["default"].property("items", _flowRuntime["default"].array(_flowRuntime["default"].ref(OptionDefinition))), _flowRuntime["default"].property("type", _flowRuntime["default"].string("reasonForDonating")))));

exports.ReasonForDonatingDefinition = ReasonForDonatingDefinition;